import { COLORS } from "@/lib/api";

export const PROGRAMAS = {
  "stem-bienestar": {
    slug: "stem-bienestar",
    title: "STEM para el Bienestar Social",
    color: COLORS.lime,
    image: "/stem-header.webp",
    tagline: "Ciencia y tecnología con propósito, en manos de más niñas y mujeres.",
    intro:
      "El futuro se construye con ciencia — y también con más niñas y mujeres tomando su lugar en STEM. Este es uno de nuestros pilares: acercar la ciencia, la tecnología, la ingeniería y las matemáticas a quienes históricamente han quedado fuera.",
    blocks: [
      {
        icon: "AlertTriangle",
        text: "En América Latina y el Caribe estamos atravesando una crisis educativa que, sobre todo en niñas y mujeres, significa un acceso reducido a oportunidades de educación de calidad en ciencia, tecnología, ingeniería y matemáticas —temas referidos en conjunto como STEM, por sus siglas en inglés—. Gracias a su naturaleza innovadora y su increíble potencial para crear impacto económico, social y de empleabilidad, las carreras STEM han sido señaladas una y otra vez como herramientas clave para la construcción de un mejor futuro (UNICEF & ITU, 2020).",
      },
      {
        icon: "Wrench",
        text: "La Guía práctica de STEM para el bien social es un manual de ocho actividades que tienen como objetivo despertar la curiosidad y la creatividad de las chicas en el desarrollo de habilidades y soluciones relacionadas con STEM. ¡También incluye historias de éxito de mujeres que han generado un cambio positivo en sus comunidades a través de sus habilidades STEM! ¿Qué estás esperando? Descarga este manual y aprende las distintas formas en las que puedes generar cambio social.",
      },
    ],
    downloads: [
      { label: "Guía práctica: STEM para el bien social", file: "/docs/stem-guia.pdf" },
      { label: "Material educativo: Bitácora WiSci × JL", file: "/docs/stem-bitacora-wisci.pdf" },
    ],
  },
  "escuela-de-formacion": {
    slug: "escuela-de-formacion",
    title: "Escuela de Fortalecimiento de Liderazgos Adolescentes",
    color: COLORS.orange,
    image: "/efla-header.webp",
    tagline: "Espacios seguros donde las adolescentes toman las riendas de su vida.",
    intro:
      "¡Tú también puedes fundar una Escuela de Liderazgo! Este libro fue creado con un propósito específico: acompañar a futuras facilitadoras, talleristas y socias implementadoras de la Escuela de Fortalecimiento de Liderazgos Adolescentes (EFLA), con base en el currículo de 21 sesiones generado entre 2020 y 2021 por UNICEF, INMUJERES y Juventudes Latentes (antes Girl Up México).",
    blocks: [
      {
        icon: "BookOpen",
        text: "¿Qué es una Escuela de Fortalecimiento de Liderazgos Adolescentes? Es un espacio de aprendizaje y desarrollo dirigido a niñas y adolescentes. Pero también es mucho más que eso: para muchas participantes, este ha sido el primer espacio donde sienten que pueden hablar libremente de los temas que les preocupan. Por eso es importante que la EFLA sea también un espacio seguro que propicie el diálogo entre pares.",
      },
      {
        icon: "Sparkles",
        text: "Nace en 2019, en el contexto del marco de la prevención del embarazo adolescente como estrategia federal, mostrando que las juventudes tienen una enorme capacidad para tomar las riendas y las decisiones de su vida, para ser líderes de ella.",
      },
      {
        icon: "ShieldCheck",
        text: "Las EFLA ofrecen a sus participantes conocimientos específicos en materia de género, sexualidad y prevención de la violencia y los embarazos adolescentes. Por otro lado, las talleristas también hacen su propio recorrido de aprendizaje al reconocer el poder de las niñas y adolescentes para hacer del mundo un lugar mejor.",
      },
    ],
    downloads: [
      { label: "EFLA: Una implementación exitosa", file: "/docs/efla.pdf" },
    ],
  },
};

export const getPrograma = (slug) => PROGRAMAS[slug];
